import { hobokenConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function HobokenPage() {
  return <CityPageTemplate config={hobokenConfig} />;
}